<template>
  <div v-loading="loading">
    <div style="color: var(--el-text-color-secondary); font-size: 12px; margin-bottom: 12px">
      将 MMP 的 campaign / adset 映射到用户来源；多个 key 可指向同一来源。
    </div>
    <el-form :inline="true" @submit.prevent>
      <el-form-item label="广告 key">
        <el-input v-model="form.key" placeholder="campaign 或 adset" clearable style="width: 220px"/>
      </el-form-item>
      <el-form-item label="用户来源">
        <el-select
          v-model="form.source"
          filterable
          allow-create
          default-first-option
          clearable
          placeholder="选择或输入"
          style="width: 200px">
          <el-option v-for="k in sourceSelectOptions" :key="k" :value="k" :label="k"/>
        </el-select>
      </el-form-item>
      <el-form-item>
        <el-button type="primary" :loading="saving" @click="save">添加 / 更新</el-button>
      </el-form-item>
    </el-form>
    <el-table :data="mapList" style="width: 100%; margin-top: 8px">
      <el-table-column prop="key" label="广告 key (campaign/adset)" min-width="200"/>
      <el-table-column prop="source" label="用户来源" min-width="160"/>
      <el-table-column label="操作" width="120">
        <template #default="scope">
          <el-button type="danger" link @click="removeRow(scope.row)">删除</el-button>
        </template>
      </el-table-column>
    </el-table>
  </div>
</template>

<script>
import axios from "ts-axios-new";
import { ElMessage, ElMessageBox } from "element-plus";

function apiError(e) {
  const m =
    e?.response?.data?.message ||
    e?.response?.data?.status?.message ||
    (typeof e?.response?.data === "string" ? e.response.data : null) ||
    e?.message;
  ElMessage.error(m || "请求失败");
}

export default {
  name: "RookieAdFromMap",
  props: {
    validSources: { type: Array, default: () => [] },
  },
  emits: ["changed"],
  data() {
    return {
      loading: false,
      saving: false,
      mapList: [],
      form: {
        key: "",
        source: "",
      },
    };
  },
  computed: {
    sourceSelectOptions() {
      const cur = this.form.source;
      const base = (this.validSources || []).filter(Boolean);
      if (cur && !base.includes(cur)) return [...base, cur];
      return base;
    },
  },
  methods: {
    init() {
      this.loading = true;
      axios
        .get("/cms/v1/country/manual/source-map")
        .then((res) => {
          this.mapList = res.data.data.mapList || [];
        })
        .catch((e) => {
          apiError(e);
        })
        .finally(() => {
          this.loading = false;
        });
    },
    save() {
      const key = (this.form.key || "").trim();
      const source = (this.form.source || "").trim();
      if (!key) {
        ElMessage.warning("请输入广告 key");
        return;
      }
      if (!source || source.toLowerCase() === "default") {
        ElMessage.warning("用户来源须为非空且非 default");
        return;
      }
      this.saving = true;
      axios
        .post("/cms/v1/country/manual/source-map", { key, source })
        .then(() => {
          ElMessage.success("已保存");
          this.form = { key: "", source: "" };
          this.init();
          this.$emit("changed");
        })
        .catch((e) => {
          apiError(e);
        })
        .finally(() => {
          this.saving = false;
        });
    },
    removeRow(row) {
      ElMessageBox.confirm(
        `确认删除映射「${row.key} → ${row.source}」？`,
        "删除映射",
        { type: "warning" },
      )
        .then(() => {
          this.loading = true;
          return axios.delete(`/cms/v1/country/manual/source-map/${row.id}`);
        })
        .then(() => {
          ElMessage.success("已删除");
          this.init();
          this.$emit("changed");
        })
        .catch((e) => {
          if (e !== "cancel" && e !== "close") apiError(e);
        })
        .finally(() => {
          this.loading = false;
        });
    },
  },
  mounted() {
    this.init();
  },
};
</script>
